import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { Row, Col } from "react-bootstrap";

import React from "react";

const ErrorMessageListQAFlags = (props) => {
  const { badges, setSelectedBadge } = props;

  function formatDate(date) {
    const now = new Date();
    const targetDate = new Date(date);
    const diffInDays = Math.floor((now - targetDate) / (1000 * 60 * 60 * 24));

    if (diffInDays === -1) {
      return "Today";
    } else if (diffInDays === 0) {
      return "Yesterday";
    } else {
      return diffInDays - 1 + " days ago";
    }
  }

  return (
    <Card className="bg-gray bg-EFEFEF">
      {" "}
      <Card.Body>
        <Row>
          <Col>
            <span className="textSmallFontBig generalFont">Flags Applied</span>
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <h4>
              {badges.length > 0 &&
                badges.map((badge) => {
                  return (
                    <>
                      <Badge
                        pill
                        bg="light"
                        className="badge"
                        onClick={() => setSelectedBadge(badge)}
                      >
                        {badge.flag}
                        <span
                          className="remove-badge"
                          onClick={(event) => {
                            event.stopPropagation();
                            props.removeBadge(badge.qaFlagId);
                            setSelectedBadge(null);
                          }}
                        >
                          {"  "}&times;{"  "}
                        </span>
                      </Badge>{" "}
                    </>
                  );
                })}
            </h4>{" "}
          </Col>
        </Row>
        <hr className="divider" />

        <span className="textSmallFontBig generalFont">QA Comments</span>
        <br />
        <br />
        {badges.length > 0 &&
          badges.map((badge) => {
            return (
              <>
                {badge.comment !== "" && (
                  <>
                    <Row xs="auto" key={badge.flag}>
                      <Col></Col>
                      <Col>
                        <>
                          <b>{badge.flag}</b> -- {formatDate(badge.updatedDate)}{" "}
                        </>
                        <br />
                        <>
                          {badge.comment !== null
                            ? badge.comment
                            : "NO COMMENTS"}{" "}
                        </>
                      </Col>
                    </Row>
                    <br />
                  </>
                )}
              </>
            );
          })}
      </Card.Body>
    </Card>
  );
};

export default ErrorMessageListQAFlags;
